import React, { useState, useEffect } from "react";
import "../css/Contact.css"; // Import the CSS file for styling
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

export default function Contact() {
  // Base URL for API calls
  const baseUrl = process.env.REACT_APP_NODE_ENV === 'production' 
    ? process.env.REACT_APP_PRODUCTION_BASE_URL 
    : process.env.REACT_APP_DEVELOPMENT_BASE_URL;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    // license: "none",
    message: "",
    services: [],
  });

  const [captcha, setCaptcha] = useState({ svg: "", sessionId: "" });
  const [captchaValue, setCaptchaValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Load captcha when component mounts
  // useEffect(() => {
  //    window.scrollTo(0, 0);
  //   loadCaptcha();
  // }, []);

  useEffect(() => {
    loadCaptcha();
   }, []);

  const loadCaptcha = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/user/generate-captcha`
      );
      if (response.data.success) {
        setCaptcha({
          svg: response.data.data,
          sessionId: response.data.sessionId,
        });
        setCaptchaValue("");
      } else {
        console.error("Failed to load captcha:", response.data);
        notifyError("Failed to load captcha");
      }
    } catch (err) {
      console.error("Error loading captcha:", err);
      notifyError("Failed to load captcha. Please refresh the page.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const notifySuccess = (message) => toast.success(message);
  const notifyError = (error) => toast.error(error);
  const handleSelectChange = (event) => {
    const selectedService = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      services: [selectedService], // Updating services as an array
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    try {
      setIsSubmitting(true);

      if (!captchaValue.trim()) {
        notifyError("Please enter the captcha text");
        return;
      }

      if (!captcha.sessionId) {
        notifyError("Captcha session expired. Please refresh the captcha.");
        loadCaptcha();
        return;
      }

      const response = await axios.post(
        `${baseUrl}/api/user/create-inquiry`,
        {
          fullName: formData.name,
          email: formData.email,
          phone: formData.phone,
          // license: formData.license,
          message: formData.message,
          service: formData.services[0],
          captchaSessionId: captcha.sessionId,
          captchaValue: captchaValue,
        }
      );

      console.log("Response:", response.data);
      notifySuccess(response.data.message);

      // Reset form and captcha
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        services: [],
      });
      setCaptchaValue("");
      loadCaptcha();
    } catch (err) {
      console.error("Error submitting inquiry:", err);
      const errorMessage =
        err.response?.data?.error || "Something went wrong. Please try again.";
      notifyError(errorMessage);

      if (errorMessage.toLowerCase().includes("captcha")) {
        loadCaptcha();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Toaster position="bottom-right" />
      <section class="who_is_good program_details main_contact_new">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 mb-3 mb-md-0">
              <div class="">
                <h4>Contact Our Driving School</h4>
                <div class="mb-3">
                  <p class="w-100">
                    Get in touch with our expert instructors and start your
                    driving journey today!
                  </p>
                </div>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2775.751839660907!2d-79.74971882411887!3d43.69644504963327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b15f3e9aae037%3A0x53ab5f6f83cc562a!2s239%20Queen%20St%20E%2C%20Brampton%2C%20ON%20L6V%201C2%2C%20Canada!5e1!3m2!1sen!2sin!4v1741852746337!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div class="col-lg-6">
              <div class="content">
                <div>
                  {/* Tabs Navigation */}
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Contact Form
                      </button>
                    </li>
                  </ul>

                  {/* Tabs Content */}
                  <div className="tab-content mt-3" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-group col-md-6 col-12 mb-3">
                            <label htmlFor="name">Full Name</label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              placeholder="John Doe"
                              value={formData.name}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="form-group col-md-6 col-12 mb-3">
                            <label htmlFor="email">Email Address</label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              placeholder="name@example.com"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="form-group col-md-6 col-12 mb-3">
                            <label htmlFor="phone">Phone Number</label>
                            <input
                              type="tel"
                              id="phone"
                              name="phone"
                              placeholder="(123) 456-7890"
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="form-group col-md-6 col-12 mb-3">
                            <label htmlFor="license">
                              Current License Status
                            </label>
                            <select
                              id="license"
                              name="license"
                              value={formData.license}
                              onChange={handleChange}
                            >
                              <option value="none">No License</option>
                              <option value="permit">Learner's Permit</option>
                              <option value="provisional">
                                Provisional License
                              </option>
                              <option value="full">Full License</option>
                              <option value="international">
                                International License
                              </option>
                            </select>
                          </div>
                        </div>

                        <div className="form-group mb-3">
                          <label className="services-label" htmlFor="services">
                            Interested Program
                          </label>
                          <select
                            id="services"
                            name="services"
                            className="services-dropdown"
                            onChange={handleSelectChange}
                          >
                            <option value="">Select a service</option>
                            <option value="beginnerLessons">
                              Beginner Driver Education Program
                            </option>
                            <option value="defensiveDriving">
                              Advanced Beginner Driver Education Program
                            </option>
                            <option value="testPrep">
                              Special Road Test Packages
                            </option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="message">Your Message</label>
                          <textarea
                            id="message"
                            name="message"
                            placeholder="Tell us about your driving goals..."
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>

                        <div className="form-group mb-4">
                          <label>
                            Verify Captcha <span className="asterisk">*</span>
                            <small className="text-muted">
                              (Case Sensitive)
                            </small>
                          </label>
                          <div className="captcha-container">
                            {captcha.svg ? (
                              <div
                                className="captcha-image"
                                dangerouslySetInnerHTML={{
                                  __html: captcha.svg,
                                }}
                              />
                            ) : (
                              <div className="captcha-image">
                                Loading captcha...
                              </div>
                            )}
                            <button
                              type="button"
                              className="btn-refresh-captcha"
                              onClick={loadCaptcha}
                              title="Refresh Captcha"
                            >
                              ↻
                            </button>
                          </div>
                          <input
                            type="text"
                            value={captchaValue}
                            onChange={(e) => setCaptchaValue(e.target.value)}
                            placeholder="Enter the characters exactly as shown"
                            required
                            className="captcha-input"
                            maxLength={5}
                          />
                        </div>

                        <button type="submit" className="btn1 w-100">
                          <i className="bi bi-send-fill me-2"></i>
                          Send Message
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
    // <div className="contact-container">
    //     <div className="contact-card">
    //         <div className="contact-header">
    //             <h1>Contact Our Driving School</h1>
    //             <p>Get in touch with our expert instructors and start your driving journey today!</p>
    //         </div>
    //         <div className="contact-body">
    //             <form onSubmit={handleSubmit}>
    //                 <div className="form-row">
    //                     <div className="form-group">
    //                         <label htmlFor="name">Full Name</label>
    //                         <input
    //                             type="text"
    //                             id="name"
    //                             name="name"
    //                             placeholder="John Doe"
    //                             value={formData.name}
    //                             onChange={handleChange}
    //                             required
    //                         />
    //                     </div>
    //                     <div className="form-group">
    //                         <label htmlFor="email">Email Address</label>
    //                         <input
    //                             type="email"
    //                             id="email"
    //                             name="email"
    //                             placeholder="name@example.com"
    //                             value={formData.email}
    //                             onChange={handleChange}
    //                             required
    //                         />
    //                     </div>
    //                 </div>

    //                 <div className="form-row">
    //                     <div className="form-group">
    //                         <label htmlFor="phone">Phone Number</label>
    //                         <input
    //                             type="tel"
    //                             id="phone"
    //                             name="phone"
    //                             placeholder="(123) 456-7890"
    //                             value={formData.phone}
    //                             onChange={handleChange}
    //                         />
    //                     </div>
    //                     <div className="form-group">
    //                         <label htmlFor="license">Current License Status</label>
    //                         <select
    //                             id="license"
    //                             name="license"
    //                             value={formData.license}
    //                             onChange={handleChange}
    //                         >
    //                             <option value="none">No License</option>
    //                             <option value="permit">Learner's Permit</option>
    //                             <option value="provisional">Provisional License</option>
    //                             <option value="full">Full License</option>
    //                             <option value="international">International License</option>
    //                         </select>
    //                     </div>
    //                 </div>

    //                 <div className="form-group">
    //                     <label className="services-label" htmlFor="services">
    //                         Interested Services
    //                     </label>
    //                     <select
    //                         id="services"
    //                         name="services"
    //                         className="services-dropdown"
    //                         onChange={handleSelectChange}
    //                     >
    //                         <option value="">Select a service</option>
    //                         <option value="beginnerLessons">Beginner Driver Education Program</option>
    //                         <option value="defensiveDriving">Advanced Beginner Driver Education Program</option>
    //                         <option value="testPrep">Special Road Test Packages</option>
    //                     </select>
    //                 </div>

    //                 <div className="form-group">
    //                     <label htmlFor="message">Your Message</label>
    //                     <textarea
    //                         id="message"
    //                         name="message"
    //                         placeholder="Tell us about your driving goals..."
    //                         value={formData.message}
    //                         onChange={handleChange}
    //                         required
    //                     ></textarea>
    //                 </div>

    //                 <button type="submit" className="submit-button">
    //                     <i className="bi bi-send-fill"></i>
    //                     Send Message
    //                 </button>
    //             </form>
    //         </div>
    //     </div>
    // </div>
  );
}
